"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTeleport = useTeleport;
const vue_demi_1 = require("vue-demi");
/**
 * 使用传送
 * @param {HTMLElement} to 传送到的节点
 */
function useTeleport(to = document.body) {
    if (to instanceof HTMLElement) {
        (0, vue_demi_1.onMounted)(() => {
            var _a;
            const $el = (_a = (0, vue_demi_1.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.proxy.$el;
            $el && to.appendChild($el);
        });
        (0, vue_demi_1.onBeforeUnmount)(() => {
            var _a;
            const $el = (_a = (0, vue_demi_1.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.proxy.$el;
            $el === null || $el === void 0 ? void 0 : $el.remove();
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidXNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBTUEsa0NBV0M7QUFqQkQsdUNBQTBFO0FBRTFFOzs7R0FHRztBQUNILFNBQWdCLFdBQVcsQ0FBQyxFQUFFLEdBQUcsUUFBUSxDQUFDLElBQUk7SUFDMUMsSUFBSSxFQUFFLFlBQVksV0FBVyxFQUFFLENBQUM7UUFDNUIsSUFBQSxvQkFBUyxFQUFDLEdBQUcsRUFBRTs7WUFDWCxNQUFNLEdBQUcsR0FBRyxNQUFBLElBQUEsNkJBQWtCLEdBQUUsMENBQUUsS0FBSyxDQUFDLEdBQUcsQ0FBQztZQUM1QyxHQUFHLElBQUksRUFBRSxDQUFDLFdBQVcsQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUMvQixDQUFDLENBQUMsQ0FBQztRQUNILElBQUEsMEJBQWUsRUFBQyxHQUFHLEVBQUU7O1lBQ2pCLE1BQU0sR0FBRyxHQUFHLE1BQUEsSUFBQSw2QkFBa0IsR0FBRSwwQ0FBRSxLQUFLLENBQUMsR0FBRyxDQUFDO1lBQzVDLEdBQUcsYUFBSCxHQUFHLHVCQUFILEdBQUcsQ0FBRSxNQUFNLEVBQUUsQ0FBQztRQUNsQixDQUFDLENBQUMsQ0FBQztJQUNQLENBQUM7QUFDTCxDQUFDIn0=